import {
  DateFnsUtils,
  FormFieldModel,
  FormFieldTypes,
  FormFieldValidator,
} from '@alfresco/adf-core';

export class DateFieldValidator implements FormFieldValidator {
  private readonly supportedTypes = [FormFieldTypes.DATE];

  // Validates that the input string is a valid date formatted as <dateFormat> (default D-M-YYYY)
  static isValidDate(inputDate: string, dateFormat = 'D-M-YYYY'): boolean {
    return DateFnsUtils.isValidDate(inputDate, dateFormat);
  }

  isSupported(field: FormFieldModel): boolean {
    return field && this.supportedTypes.indexOf(field.type) > -1;
  }

  validate(field: FormFieldModel): boolean {
    if (this.isSupported(field) && field.value && field.isVisible) {
      if (
        DateFieldValidator.isValidDate(field.value, field.dateDisplayFormat)
      ) {
        return true;
      }
      field.validationSummary.message = field.dateDisplayFormat;
      return false;
    }
    return true;
  }
}

export class WkDueDateValidator extends DateFieldValidator {
  validate(field: FormFieldModel): boolean {
    const fieldRepresentation = field.fields['1']?.[0] || field;
    if (
      this.isSupported(fieldRepresentation) &&
      fieldRepresentation.id.includes('duedate') &&
      field.form.values.duedate
    ) {
      const dateSelected = DateFnsUtils.parseDate(
        field.form.values.duedate.split('T')[0],
        'yyyy-MM-dd'
      );
      if (this.compareDates(dateSelected, new Date())) {
        return true;
      }
      if (!field.form.values.duedate && field.form.isValid()) {
        return true;
      }
      return false;
    }
    return true;
  }

  private compareDates(fieldDate: Date, todaysDate: Date): boolean {
    todaysDate.setHours(0, 0, 0, 0);
    return fieldDate >= todaysDate;
  }
}
